<template>
  <div class="image-upload">
    <div v-if="displayUrl" class="preview">
      <img :src="displayUrl" alt="预览">
      <div class="preview-actions">
        <el-upload
          action="#"
          :auto-upload="false"
          :show-file-list="false"
          accept="image/*"
          :disabled="uploading"
          :on-change="handleChange"
        >
          <el-button size="mini" :loading="uploading">更换</el-button>
        </el-upload>
        <el-button size="mini" type="text" class="danger" @click="clear">移除</el-button>
      </div>
    </div>
    <el-upload
      v-else
      action="#"
      :auto-upload="false"
      :show-file-list="false"
      accept="image/*"
      :disabled="uploading"
      :on-change="handleChange"
    >
      <el-button size="small" type="primary" :loading="uploading">{{ buttonText }}</el-button>
    </el-upload>
    <div v-if="hint" class="hint">{{ hint }}</div>
  </div>
</template>

<script>
import { uploadFile } from '@/api/upload'
import { normalizeFileUrl, resolveFileUrl } from '@/utils/fileUrl'

const MAX_SIZE = 10 * 1024 * 1024
const ALLOWED_IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp']

export default {
  name: 'ImageUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    bizType: {
      type: String,
      default: 'common'
    },
    buttonText: {
      type: String,
      default: '上传图片'
    },
    hint: {
      type: String,
      default: '支持 JPG/PNG/GIF/WebP，不超过 10MB'
    }
  },
  data() {
    return {
      uploading: false
    }
  },
  computed: {
    displayUrl() {
      return resolveFileUrl(this.value)
    }
  },
  methods: {
    clear() {
      this.$emit('input', '')
    },
    async handleChange(fileObj) {
      const file = fileObj && fileObj.raw
      if (!file) return
      if (!file.type.startsWith('image/')) {
        this.$message.warning('请选择图片文件')
        return
      }
      const ext = (file.name.split('.').pop() || '').toLowerCase()
      if (!ALLOWED_IMAGE_EXT.includes(ext)) {
        this.$message.warning('不支持的图片格式')
        return
      }
      if (file.size > MAX_SIZE) {
        this.$message.warning('图片大小不能超过 10MB')
        return
      }
      this.uploading = true
      try {
        const result = await uploadFile(file, this.bizType, { useAdmin: true })
        this.$emit('input', normalizeFileUrl(result.url))
        this.$message.success('上传成功')
      } catch (e) {
        // 错误由 request 拦截器统一弹框
      } finally {
        this.uploading = false
      }
    }
  }
}
</script>

<style scoped>
.image-upload {
  line-height: 1.4;
}
.preview {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.preview img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background: #f5f7fa;
}
.preview-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.hint {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}
.danger {
  color: #f56c6c;
}
</style>
